/**
 * Поиск значения заголовка с возможностью извлечения подстроки по имени параметра
 * @param {Object} headers - Объект с заголовками
 * @param {string} headerName - Имя заголовка (без учета регистра)
 * @param {string} [paramName] - Имя параметра для извлечения (например, 'filename')
 * @returns {string|null}
 */
export default function findHeaderValue(headers, headerName, paramName) {
    for (const key in headers) {
        if (new RegExp(`^${headerName}$`, 'i').test(key)) {
            const value = headers[key];

            if (!paramName || !value) {
                return value;
            }

            // Ищем все совпадения параметра (включая повторы)
            const regex = new RegExp(`${paramName}\\s*=\\s*"?([^;\r\n"]+)"?`, 'gi');
            const matches = [];
            let match;

            while ((match = regex.exec(value)) !== null) {
                matches.push(match[1]);
            }

            // Возвращаем последнее найденное значение
            return matches.length > 0 ? matches[matches.length - 1].trim() : null;
        }
    }
    return null;
}
